<script>
  import solicitacaoBolsaServico from '../../servico';
  import FileInput from '~componentes/InputFile.vue';
  import 'vue-strap/dist/vue-strap-lang';
  
  export default {
    components: { FileInput },
    props: {
        solicitacao: {
            type: Object,
            required: true
        },
      //Lista de objetos bolsa que contém idSolicitacaoTipoArquivo, idSolicitacaoBolsa e nomeArquivo
      bolsas: {
        type: Array,
        required: true,
      },
      //Arquivos enviados pelo usuário
      arquivosBolsas: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {      
        bolsa: this.camposBolsa(),
        arquivo: [],
        arquivosDeletados: [],
        tipoArquivoBolsa: [],
        tipoArquivoBolsaAtivo: [],
        tipoArquivoBolsaObrigatorio: [],
        nomeTipoArquivoBolsaObrigatorio: [],
        tipoArquivoPadrao: 0,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {


            if ('size' in this.$refs.fileInput.arquivo && this.$refs.fileInput.arquivo.size === 0) {
              this.$swal({
                title: 'Arquivo Inválido',
                html: 'O arquivo a ser adicionado não pode estar vazio ou ter tamanho de 0KB.',
                type: 'error',
                confirmButtonText: 'Ok, entendi!',
                allowOutsideClick: false,
                allowEscapeKey: false,
              });

              return false;
            }
            if (valido) {
              this.adicionar();
            }
          })
      },

      nomeTipoArquivoBolsa(id) {
        return this.tipoArquivoBolsa.find(tipoArquivo => {
          return tipoArquivo.idSolicitacaoTipoArquivo === id;
        }).tipoArquivo;
      },

      async adicionar() {
        const copiaBolsa = Object.assign(this.bolsa);
        if (this.tipoArquivoPadrao > 0) {
          copiaBolsa.idSolicitacaoTipoArquivo = this.tipoArquivoPadrao;
        }
        if (this.$refs.fileInput.arquivo) {
          copiaBolsa.nomeArquivo = this.$refs.fileInput.arquivo.name;
          if (this.$refs.fileInput.length != 0) {
            this.arquivosBolsas.push(this.arquivo);
          }
        } else {
          copiaBolsa.nomeArquivo = this.$refs.fileInput.arquivo
            ? this.$refs.fileInput.arquivo.name
            : 'Sem arquivo';
        }

        // Verificação da lista dos removidos.
        const indice = this.arquivosDeletados.indexOf(copiaBolsa.nomeArquivo);
        if (indice > -1) {
          this.arquivosDeletados.splice(indice, 1);
        }

        this.bolsas.push(copiaBolsa);
        this.bolsa = this.camposBolsa();
        this.$refs.fileInput.removerArquivo();
        this.$validator.reset();
      },

      deletar(indice) {
        this.arquivosDeletados.push(this.bolsas[indice].nomeArquivo)
        this.bolsas.splice(indice, 1);
      },

      editar(indice) {
        const bolsa = this.bolsas[indice];

        this.arquivosDeletados.push(this.bolsas[indice].nomeArquivo)
        this.bolsas.splice(indice, 1);

        this.bolsa.idSolicitacaoBolsaArquivo = bolsa.idSolicitacaoBolsaArquivo;

        for (let i in this.tipoArquivoBolsaAtivo) {
          if (bolsa.idSolicitacaoTipoArquivo == this.tipoArquivoBolsaAtivo[i].idSolicitacaoTipoArquivo) {
            this.bolsa.idSolicitacaoTipoArquivo = bolsa.idSolicitacaoTipoArquivo;
            break;
          }
        }

        this.bolsa.idSolicitacaoBolsa = bolsa.idSolicitacaoBolsa;

        this.$refs.fileInput.arquivo = [];
        this.$refs.fileInput.arquivo.name = bolsa.nomeArquivo;
        this.arquivo = [];
        this.arquivo.name = bolsa.nomeArquivo;
      },

      download(arquivoBolsa) {
        solicitacaoBolsaServico.downloadBolsaArquivo(arquivoBolsa.idSolicitacaoBolsa, arquivoBolsa.nomeArquivo)
          .then(arquivo => {
          arquivo.download();
        });
      },

      validarArquivo() {
        if (this.tipoArquivoBolsa == null || this.tipoArquivoBolsa.length == 0) {
          return '';
        }
        
        if (this.arquivo != null) {
          if (this.arquivo.name != null && this.arquivo.name != '' && typeof this.arquivo.name !== 'undefined') {
            return '';
          }
        }
        return 'required';
      },

      preencherTiposAtivos() {
        for (var tipo of this.tipoArquivoBolsa) {
          if (tipo.ativo) {
           this.tipoArquivoBolsaAtivo.push(tipo);
          }
        }
        this.verificarTipoArquivoPadrao();
      },

      preencherTiposObrigatorios() {
        var tipoArquivoBolsaObrigatorio = [];
        var nomeTipoArquivoBolsaObrigatorio = [];
        this.tipoArquivoBolsaAtivo.map(function (tipoArquivo) {
          if (tipoArquivo.obrigatorio) {
            tipoArquivoBolsaObrigatorio.push(tipoArquivo.idSolicitacaoTipoArquivo);
            nomeTipoArquivoBolsaObrigatorio.push(tipoArquivo.tipoArquivo);
          }
        });
        this.tipoArquivoBolsaObrigatorio = tipoArquivoBolsaObrigatorio;
        this.nomeTipoArquivoBolsaObrigatorio = nomeTipoArquivoBolsaObrigatorio;
      },

      validarArquivosObrigatorios(forcarValidarArquivo) {
        if (this.tipoArquivoBolsaAtivo.length == 1) {
            if (this.configuracao.obrigatorioArquivoSolBolsa || forcarValidarArquivo) {
                    let existeArquivo = false;
                    for (let arquivo of this.arquivosBolsas) {
                        if (arquivo) {
                            existeArquivo = true;
                            break;
                        }
                    }

                    for (let arquivo of this.bolsas) {
                        if (arquivo) {
                            existeArquivo = true;
                            break;
                        }
                    }

                    return existeArquivo;
            }
        }   

        var tipoArquivoExistentes = [];
        this.bolsas.map(function (e) {
          tipoArquivoExistentes.push(e.idSolicitacaoTipoArquivo);
        });

        for (var tipo of this.tipoArquivoBolsaObrigatorio) {
          if (!tipoArquivoExistentes.includes(tipo)) {
            return false;
          }
        } 

        return true;
      },

      validarArquivoPendente() {
        return this.$refs.fileInput.arquivo ? false : true;
      },

      verificarTipoArquivoPadrao() {
        if (this.tipoArquivoBolsaAtivo.length == 1 && this.tipoArquivoBolsaAtivo[0].tipoArquivo === 'Sem Tipo Definido') {
          this.tipoArquivoPadrao = this.tipoArquivoBolsaAtivo[0].idSolicitacaoTipoArquivo;
        } else {
          this.tipoArquivoPadrao = 0;
        }
      },

      carregarTipoArquivo() {
        solicitacaoBolsaServico.carregarTipoArquivo()
          .then(tipoArquivo => {
            this.tipoArquivoBolsa = tipoArquivo;
            this.preencherTiposAtivos();
            this.preencherTiposObrigatorios();
            this.arquivo = [];

          });
      },


      camposBolsa() {
        return {
            idSolicitacaoBolsaArquivo: 0,
            idSolicitacaoTipoArquivo: '',
            idSolicitacaoBolsa: '',
            nomeArquivo: '',
          }
        }
    },
    mounted() {
      this.carregarTipoArquivo();
    },
    computed: {
      nomeTipoSolicitacao() {
        switch (this.solicitacao.tipoBolsa) {
          case 1: return "bolsa";
            break;
          case 2: return "RPA";
            break;
          case 3: return "estágio";
            break;
          case 4: return "termo aditivo";
            break;
          case 5: return "adicional variável";
            break;
          default: return "";
            break;
        }
      }
    },
  }
</script>

<template>
  <div>
    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
          <tr>
            <th v-show="tipoArquivoPadrao == 0">Tipo Arquivo</th>
            <th>Nome Arquivo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(bolsa, indice) in bolsas">
            <td v-show="tipoArquivoPadrao == 0">{{ nomeTipoArquivoBolsa(bolsa.idSolicitacaoTipoArquivo) }}</td>
            <td>{{ bolsa.nomeArquivo }}</td>
            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
            <td v-if="bolsa.nomeArquivo !== 'Sem arquivo' && bolsa.idSolicitacaoBolsaArquivo !== 0" class="action">
              <button type="button"
                      class="btn btn-xs btn-success"
                      @click="download(bolsa)">
                <i class="fa fa-download"></i>
              </button>
            </td>
          </tr>
          <tr v-if="bolsas.length === 0">
            <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row" v-show="tipoArquivoPadrao == 0">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('idSolicitacaoTipoArquivo')}">
          <label class="control-label" for="id-SolicitacaoTipoArquivo">Tipo Arquivo</label>
          <select class="form-control"
                  id="id-SolicitacaoTipoArquivo"
                  v-model="bolsa.idSolicitacaoTipoArquivo"
                  data-vv-name="idSolicitacaoTipoArquivo"
                  data-vv-as="idSolicitacaoTipoArquivo"
                  v-validate="tipoArquivoPadrao == 0 ? 'required' : ''">
            <option value="">Selecione...</option>
            <option :value="tipoArquivo.idSolicitacaoTipoArquivo" v-for="tipoArquivo in tipoArquivoBolsaAtivo">{{ tipoArquivo.tipoArquivo }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('idSolicitacaoTipoArquivo')">{{ errors.first('idSolicitacaoBolsaArquivo') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('arquivo')}">
          <label class="control-label" for="id-arquivo-bolsa">Arquivo {{nomeTipoSolicitacao}}</label>

          <file-input data-vv-name="arquivo"
                      id="id-arquivo-bolsa"
                      data-vv-as="arquivo"
                      v-model="arquivo"
                      ref="fileInput"
                      v-validate="validarArquivo()">
          </file-input>

          <p class="text-danger" v-show="errors.has('arquivo')">{{ errors.first('arquivo') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <button type="button"
                  class="btn btn-success"
                  @click="validar">
            <i class="fa fa-plus"></i> Adicionar Arquivo
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <p class="text-danger" v-show="tipoArquivoPadrao == 0 && nomeTipoArquivoBolsaObrigatorio.length > 0">
          Arquivo(s) obrigatório(s): {{ nomeTipoArquivoBolsaObrigatorio.join(', ') }}
        </p>        
      </div>
    </div>


  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa/componentes/compartilhado/FormArquivoBolsa.vue